import Resource from './resource';
import request from "../utils/request";

class TopicsCard extends Resource {
    constructor() {
        super('topics_card');
    }

    store(resource) {
        return request({
            url: `/topics_card/store`,
            method: 'post',
            data: resource
        })
    }

    list(resource) {
        return request({
            url: `/topics_card/list`,
            method: 'POST',
            data: resource
        })
    }

    delete(id) {
        return request({
            url: `/topics_card/delete/${id}`,
            method: 'delete',
        })
    }

    lookups() {
        return request({
            url: `/topics_card/lookups`,
            method: 'get',
        })
    }

    // Add other methods if needed in the future, following the pattern
    // For now, only store endpoint is requested as per: "this api endpoint is /topics_card/store"
    // Wait, usually 'store' implies saving, but the user said "Datatable with data returned from vuex store create a new module and create a new api file also and this api endpoint is /topics_card/store"
    // It's ambiguous if they mean "store" as in "save" or just the name of the endpoint to "get" data (like a post search).
    // Given it's for a DataTable, it's likely a POST request to fetch/search data (common pattern in this app seen in topics.js -> topics(resource) uses POST /topics).
    // I will assume it's for fetching data.
}

export { TopicsCard as default };
